import { render } from "./keyAreaMonitor.vue?vue&type=template&id=537ee83d&scoped=true"
import script from "./keyAreaMonitor.vue?vue&type=script&lang=js"
export * from "./keyAreaMonitor.vue?vue&type=script&lang=js"

import "./keyAreaMonitor.vue?vue&type=style&index=0&id=537ee83d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537ee83d"]])

export default __exports__